define(['handlebars'], function (handlebars) {
    return function (data, length) {
        if (data.length > length) {
            data = '<span class="trimmed-text">' + data.substring(0, length) + '</span><span class="trimmed-ellipsis">...</span>' + '<span class="trimmed-full-text">' + data.substring(length) + '</span> <a href="#" class="dynamic-button-text trimmed-read-more">Read more</a>';
        }
        return new handlebars.SafeString(data);
    }
});